import {Injectable} from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {

  constructor() {
  }


  static makePrettyTime(timeString: string): string {
    return moment(timeString).format('llll zz');
  }


  /**
   *
   * @param timeString
   * @see makeSortableValueForMonospaceTime
   */
  static makeMonospaceTime(timeString: string): string {
    return moment(timeString).format('ddd, MMM DD, YYYY → hh:mm:ss A');
  }


  /**
   * Takes a value returned by makeMonospaceTime and makes it sortable but
   * not usable for end users--so only use this as a sorting value.
   *
   * @param monospaceTimeStr
   * @see makeMonospaceTime
   */
  static makeSortableValueForMonospaceTime(monospaceTimeStr: string): string {
    if (monospaceTimeStr.includes('AM')) {
      return monospaceTimeStr.replace('→', 'A');
    }

    return monospaceTimeStr.replace('→', 'P');
  }


  /**
   * Extracts error message from various backend error response formats.
   * Handles the structure: {"Error":{"Details":["..."],"Message":null,"Status":404}}
   * 
   * @param error - The error object from HTTP response
   * @returns The extracted error message string
   */
  static extractErrorMessage(error: any): string {
    if (typeof error === 'string') return error;
    if (error?.Error?.Message) return error.Error.Message;
    if (error?.Error?.Details?.[0]) return error.Error.Details[0];
    return '';
  }

}
